import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import TopInfoStrip from '../components/TopInfoStrip';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AmazonSection from '../components/AmazonSection';
import PricingSectionV2 from '../components/PricingSectionV2';
import HowItWorksSection from '../components/HowItWorksSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import CTASection from '../components/CTASection';
import InquiryModal from '../components/InquiryModal';
import {
  selfFilingProcessCards,
  attorneyLedProcessCards,
  selfFilingPlans,
  attorneyLedPlans,
} from '../mock';

const PPCLandingPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [buttonContext, setButtonContext] = useState('');
  const [selectedPackage, setSelectedPackage] = useState({ title: 'Basic', amount: 45 });
  const [tmSignUpType, setTmSignUpType] = useState(null);

  const openModal = (payload) => {
    if (typeof payload === 'string') {
      setButtonContext(payload);
      setSelectedPackage({ title: 'Basic', amount: 45 });
      setTmSignUpType(null);
    } else {
      setButtonContext(payload.context || '');
      setSelectedPackage({
        title: payload.packageTitle || 'Basic',
        amount: payload.packageAmount || 45
      });
      setTmSignUpType(payload.tmSignUpType || null);
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setButtonContext('');
    setTmSignUpType(null);
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Top Info Strip */}
      <TopInfoStrip />

      {/* Simple Header - Logo and Buttons */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="#" className="flex items-center gap-2.5" data-testid="navbar-logo">
                       
                         <img src="/assets/img/brand/logo-dark.png" alt="Logo" className="h-10" />
                      </Link>
          </div>

          {/* Buttons */}
          <div className="flex gap-3">
            <Button
              onClick={() => openModal('PPC Header - Chat Now')}
              variant="outline"
              className="border-[#044B3B] text-[#044B3B] hover:bg-[#044B3B] hover:text-white font-semibold px-6 py-2.5 rounded-md"
            >
              Chat Now
            </Button>
            <Button
              onClick={() => openModal('PPC Header - Register Now')}
              className="bg-[#044B3B] hover:bg-[#03392D] text-white font-semibold px-6 py-2.5 rounded-md"
            >
              Register Now
            </Button>
          </div>
        </div>
      </header>

      {/* All Sections from Home */}
      <HeroSection onOpenModal={openModal} />
      <ServicesSection />
      <HowItWorksSection />
      <AmazonSection onOpenModal={openModal} />
      <PricingSectionV2
        onOpenModal={openModal}
        selfFilingProcessCards={selfFilingProcessCards}
        attorneyLedProcessCards={attorneyLedProcessCards}
        selfFilingPlans={selfFilingPlans}
        attorneyLedPlans={attorneyLedPlans}
      />
      <WhyChooseUsSection />
      <TestimonialsSection />
      <CTASection onOpenModal={openModal} />

      {/* Simple Footer Bar */}
      <footer className="bg-slate-900 text-white py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © {new Date().getFullYear()}Trademark Throne. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="/privacy-policy" className="text-sm text-slate-400 hover:text-white transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-conditions" className="text-sm text-slate-400 hover:text-white transition-colors">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Inquiry Modal */}
      <InquiryModal
        isOpen={isModalOpen}
        onClose={closeModal}
        buttonContext={buttonContext}
        packageTitle={selectedPackage.title}
        packageAmount={selectedPackage.amount}
        tmSignUpType={tmSignUpType}
      />
    </div>
  );
};

export default PPCLandingPage;
